// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__v9qkM","detailsBorder":"styles_detailsBorder__1tehZ"};